<template>
  <div>
    <v-container class="container px-0">
      <v-row
        class="title-row"
        :class="`${
          $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
        }`"
      >
        <v-col class="d-flex align-center">
          <h4 class="font-weight-light">
            {{ $t("heading.reseller.page.api") }}
          </h4>
        </v-col>

        <v-col
          class="page-title__filter-controls justify-end align-end"
          v-if="apiTokens.length != 0"
          :class="[`${$vuetify.breakpoint.mobile ? 'pb-3' : ''}`]"
        >
          <DataIteratorFilterControls
            :showSearchTerm="true"
            :searchTerm="searchTerm"
            :fullWidthSearch="false"
            :fullWidthLg="false"
            :fullWidthMd="true"
            @update:searchTerm="searchTerm = $event"
            :class="'my-hostings-search'"
          ></DataIteratorFilterControls>

          <v-btn
            :large="!$vuetify.breakpoint.smAndDown"
            elevation="0"
            color="primary"
            class="p-2 add-new-button page-title__add-button"
            @click="$refs.ApiTokenCreateModal.open()"
          >
            <v-icon :class="$vuetify.breakpoint.mobile ? 'mr-0' : ''"
              >$plus
            </v-icon>
            {{ $vuetify.breakpoint.mobile ? "" : $t("button.apiToken.create") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="px-0">
      <div class="alert alert--info-bg alert--sm alert--100 mb-4">
        <div class="alert__icon-box">
          <v-icon color="info" size="20">$infoCircle</v-icon>
        </div>
        <div class="alert__text-box alert__text-box--wide d-flex flex-row">
          <span v-html="$t('reseller.apiTokens.documentationAt')"></span>&nbsp;<a :href="apiDocsUrl" target="_blank">{{ apiDocsUrl }}</a>
        </div>
      </div>
      <v-row>
        <v-col cols="12">
          <v-card elevation="4" class="data-table">
            <v-card-text v-if="!fetchingApiTokens && apiTokens.length === 0" class="d-flex flex-column align-center justify-center py-14">
              <div class="flex justify-center" style="max-width: 64px; margin: auto">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.87658 42.4792C-6.39774 33.3218 7.98605 4.27477 28.4024 0.584819C51.3092 -3.55512 67.3675 14.4446 63.3958 35.1893C59.0163 58.0715 30.2058 69.5013 21.9834 61.3789C17.153 56.609 25.2037 50.7591 19.2784 44.8867C13.3317 39.0143 7.19172 46.7541 2.85512 42.4792H2.87658Z" fill="var(--v-gray-lighten5)"/>
                  <path d="M22 48L41 48" stroke="#B0B0D3" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M32 25V45" stroke="#B0B0D3" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M46.0273 23.5198C45.233 23.5198 44.5031 23.6998 43.859 24.0373C43.859 23.6998 43.902 23.4298 43.902 23.0923C43.902 16.9724 39.0501 12 33.1034 12C28.1227 12 23.9149 15.5099 22.6698 20.2349C21.6608 19.6724 20.4585 19.3349 19.2134 19.3349C15.2417 19.3349 12 22.6423 12 26.7373C12 30.8322 15.2417 34.1397 19.2134 34.1397H46.0488C48.9041 34.1397 51.2227 31.7772 51.2227 28.8298C51.2227 25.8823 48.9041 23.5198 46.0488 23.5198H46.0273Z" fill="white" stroke="#77849F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M32 51C33.6569 51 35 49.6569 35 48C35 46.3431 33.6569 45 32 45C30.3431 45 29 46.3431 29 48C29 49.6569 30.3431 51 32 51Z" fill="white" stroke="#B0B0D3" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M43 50C44.1046 50 45 49.1046 45 48C45 46.8954 44.1046 46 43 46C41.8954 46 41 46.8954 41 48C41 49.1046 41.8954 50 43 50Z" fill="#EEEEF4" stroke="#77849F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 50C22.1046 50 23 49.1046 23 48C23 46.8954 22.1046 46 21 46C19.8954 46 19 46.8954 19 48C19 49.1046 19.8954 50 21 50Z" fill="#EEEEF4" stroke="#77849F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M35 28L29 22" stroke="#B0B0D3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M29 28L35 22" stroke="#B0B0D3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h6 class="mt-4 mb-6">
                {{ $t("reseller.apiTokens.noTokens") }}
              </h6>
              <p class="p-2 mb-6">
                {{ $t("reseller.apiTokens.noTokensDesc") }}
              </p>
              <v-btn
                :large="!$vuetify.breakpoint.smAndDown"
                elevation="0"
                color="primary"
                class="p-2 add-new-button page-title__add-button"
                @click="$refs.ApiTokenCreateModal.open()"
              >
                <v-icon :class="$vuetify.breakpoint.mobile ? 'mr-0' : ''"
                  >$plus
                </v-icon>
                {{ $vuetify.breakpoint.mobile ? "" : $t("button.apiToken.create") }}
              </v-btn>
            </v-card-text>
            <v-data-table
              v-else
              :loading="fetchingApiTokens"
              :headers="headers"
              :items="apiTokens"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
              :search="searchTerm"
              item-key="id"
              must-sort
              calculate-widths
              hide-default-header
              hide-default-footer
              class="elevation-0 custom-data-table"
              :options.sync="options"
            >
              <template v-if="fetchingApiTokens" v-slot:body>
                <template v-if="$vuetify.breakpoint.lgAndDown">
                  <logs-table-item-skeleton-mobile
                    v-for="item in 5"
                    :key="item"
                  />
                </template>
                <template v-else>
                  <logs-table-skeleton-item />
                </template>
              </template>
              <template v-slot:no-data>
                <DataIteratorNoResultsContainer
                  v-if="searchTerm"
                  @clearAllFilters="clearAllFilters"
                  :searchTerm="searchTerm"
                />
              </template>
              <template v-slot:no-results>
                <DataIteratorNoResultsContainer
                  @clearAllFilters="clearAllFilters"
                  :searchTerm="searchTerm"
                />
              </template>
              <template
                v-if="!$vuetify.breakpoint.mobile && apiTokens.length"
                v-slot:header="{ props }"
              >
                <tr class="custom-sort">
                  <td
                    v-for="header in props.headers"
                    :key="header.value"
                    class="sort-item px-4"
                    @click="header.sortable && toggleSort(header)"
                  >
                    <div
                      class="custom-sort__item"
                      :class="{
                        'custom-sort__item--sortable': header.sortable,
                      }"
                    >
                      {{ $t(`table.header.${header.text}`) }}
                      <div class="custom-sort__arrows" v-if="header.sortable">
                        <v-icon
                          size="12"
                          class="custom-sort__arrow-up"
                          :up="
                            !props.options.sortDesc[0] &&
                            props.options.sortBy[0] === header.value
                          "
                          :down="
                            props.options.sortDesc[0] &&
                            props.options.sortBy[0] === header.value
                          "
                        >
                          $arrowsSort
                        </v-icon>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <template
                v-if="$vuetify.breakpoint.mobile"
                v-slot:item="{ item, headers }"
              >
                <tr>
                  <td class="w-100">
                    <div class="mobile-table-item">
                      <div class="mobile-table-item__values">
                        <div
                          class="mobile-table-item__row"
                          v-for="header in headers"
                          :key="header.value"
                        >
                          <div class="mobile-table-item__header">
                            {{ $t(`table.header.${header.text}`) }}
                          </div>
                          <div class="mobile-table-item__value">
                            <UsersTableCell
                              :item="item"
                              :header="header"
                              isMobile
                              @action-button-delete="
                                $refs.UserDeleteModal.open($event)
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else v-slot:item="{ item, headers }">
                <tr>
                  <td v-for="header in headers" :key="header.value">
                    <ApiTokensTableCell
                      :item="item"
                      :header="header"
                      @action-button-delete="$refs.ApiTokenDeleteModal.open($event)"
                    />
                  </td>
                </tr>
              </template>
              <template v-slot:footer>
                <v-divider
                  v-if="
                    !(
                      numberOfPages === 1 &&
                      itemsPerPage === possibleItemsPerPage[listStyle][0]
                    )
                  "
                />
                <DataIteratorFooter
                  :page="page"
                  :numberOfPages="numberOfPages"
                  :possibleItemsPerPage="possibleItemsPerPage"
                  :listStyle="listStyle"
                  :itemsPerPage="itemsPerPage"
                  :itemsTotal="itemsTotal"
                  @update:page="updatePage"
                  @update:itemsPerPage="updateItemsPerPage"
                  :perPageLabel="$t('table.footer.items')"
                />
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <ApiTokenCreateModal
      ref="ApiTokenCreateModal"
      v-on="$listeners"
      @api-token-created="apiTokenCreated"
    />
    <ApiTokenDeleteModal
      ref="ApiTokenDeleteModal"
      v-on="$listeners"
      @api-token-deleted="apiTokenDeleted"
    />
  </div>
</template>

<script>
import Api from "../../apis/Api";
import ApiTokenCreateModal from "./ApiTokenCreateModal.vue";
import ApiTokenDeleteModal from "./ApiTokenDeleteModal.vue";
import ApiTokensTableCell from "./ApiTokensTableCell.vue";
import LogsTableItemSkeletonMobile from "../../components/dataIterator/tables/LogsTableItemSkeletonMobile.vue";
import LogsTableSkeletonItem from "../../components/dataIterator/tables/LogsTableSkeletonItem.vue";
import DataIteratorFilterControls from "../../components/dataIterator/DataIteratorFilterControls.vue";
import DataIteratorFooter from "../../components/dataIterator/DataIteratorFooter.vue";
import DataIteratorNoResultsContainer from "../../components/dataIterator/DataIteratorNoResultsContainer.vue";

export default {
  components: {
    ApiTokenCreateModal,
    ApiTokenDeleteModal,
    ApiTokensTableCell,
    LogsTableItemSkeletonMobile,
    LogsTableSkeletonItem,
    DataIteratorFilterControls,
    DataIteratorFooter,
    DataIteratorNoResultsContainer,
  },
  props: {},
  data() {
    return {
      fetchingApiTokens: false,
      apiTokens: [],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },
      apiDocsUrl: "https://www.panelalpha.com/api-documentation/",
      searchTerm: "",
      page: 1,
      itemsPerPage: 10,
      listStyle: 0,
      possibleItemsPerPage: [[10, 25, 50]],
      headers: [
        {
          text: "name",
          value: "name",
          sortable: true,
        },
        {
          text: "last_used_at",
          value: "last_used_at",
          sortable: true,
        },
        {
          text: "created_at",
          value: "created_at",
          sortable: true,
        },
        {
          text: "actions",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.fetchApiTokens();
  },
  methods: {
    fetchApiTokens() {
      this.fetchingApiTokens = true;
      Api.get("/reseller/api-tokens")
        .then((response) => {
          this.apiTokens = response.data.data;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.fetchingApiTokens = false;
        });
    },
    toggleSort(header) {
      if (this.options.sortBy[0] === header.value) {
        this.options.sortDesc = [!this.options.sortDesc[0]];
        return;
      }
      this.options.sortBy = [header.value];
    },
    apiTokenCreated(apiToken) {
      this.apiTokens.unshift(apiToken);
    },
    apiTokenDeleted(apiToken) {
      this.apiTokens = this.apiTokens.filter((t) => t.id !== apiToken.id);
    },
    updatePage(newPage) {
      this.page = newPage;
    },
    updateItemsPerPage(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
    },
    clearAllFilters() {
      this.searchTerm = "";
    },
  },
  watch: {
    page: function (newValue) {
      if (this.options.page !== newValue) {
        this.options.page = newValue;
      }
    },
    itemsPerPage: function (newValue) {
      if (this.options.itemsPerPage !== newValue && newValue !== -1) {
        this.options.itemsPerPage = newValue;
      }
    },
  },
  computed: {
    itemsTotal() {
      return this.apiTokens.length;
    },
    numberOfPages() {
      return Math.ceil(this.itemsTotal / this.itemsPerPage);
    },
  },
};
</script>
<style src="../../components/dataIterator/TableCustomSort.scss" lang="scss" scoped />
